(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6683],{

/***/ 6538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oppo",
      function () {
        return __webpack_require__(9153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5935);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6008);







function Accordion(param) {
    var items = param.items, openItem = param.openItem, blueTheme = param.blueTheme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(openItem || ""), selected = ref[0], setSelected = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("mx-4 my-0 list-none rounded bg-transparent px-8 tablet:mx-auto tablet:my-auto  tablet:mt-4", blueTheme && "  bg-white"),
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionItem, {
                content: item.content,
                isOpen: item.title === selected,
                title: item.title,
                setSelected: setSelected,
                blueTheme: blueTheme
            }, item.title);
        })
    });
}
function AccordionItem(param) {
    var isOpen = param.isOpen, title = param.title, content = param.content, setSelected = param.setSelected, blueTheme = param.blueTheme;
    var isOpenProps = {
        Container: "pb-6",
        Button: "isOpenAccordion mb-4 [&>svg]:rotate-180"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("border-0 border-b-[0.5px] border-solid border-b-mglGray200 bg-mglGray50 py-8", blueTheme && "  bg-white", isOpen && isOpenProps.Container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex w-full appearance-none items-center justify-between gap-8 border-none bg-mglGray50 [&>h2]:w-full [&>h2]:text-left [&>h2]:text-lg [&>svg]:transition-all [&>svg]:duration-300 [&>svg]:ease-ease", isOpen && isOpenProps.Button, blueTheme && "bg-white", "transition-all duration-[600ms]"),
                onClick: function() {
                    return setSelected(isOpen ? "" : title);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: title
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        icon: "mdi:chevron-down",
                        width: 18,
                        height: 18,
                        color: blueTheme ? _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglBlue.mglBlue400 */ .Db.mglBlue400 : _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray900 */ .Ce.mglGray900
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__/* .DivContentNews */ ._7, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("m-0 h-auto max-h-0 w-full overflow-hidden text-mglGray900 opacity-0 transition-all duration-[600ms] first:mt-2", isOpen && "max-h-screen opacity-100"),
                children: typeof content === "object" ? content : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(content)
            })
        ]
    });
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 8157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedProductExclusive; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function FeaturedProductExclusive(param) {
    var _onHome = param.onHome, onHome = _onHome === void 0 ? false : _onHome;
    var textsLinks = {
        onHome: {
            title: "Sobre OPPO",
            subtitle: null,
            describe: "Junte-se \xe0 OPPO e transforme cada momento em algo extraordin\xe1rio.",
            link: "/oppo"
        },
        onLp: {
            title: "Ofertas OPPO",
            subtitle: "As Melhores ofertas",
            describe: "Aproveite as ofertas exclusivas em produtos OPPO e eleve sua experi\xeancia tecnol\xf3gica.",
            link: "https://ofertas.canaltech.com.br/marca/oppo/"
        }
    };
    var backgroundOppo = "https://t.ctcdn.com.br/QFdnjPQOAnsY-aHSkABkXT-BcN4=/i1068821.jpeg";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex w-full gap-5 phone:flex-col"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: onHome ? textsLinks.onHome.link : textsLinks.onLp.link,
            title: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
            target: "_blank",
            className: "group w-full no-underline",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex h-[375px] flex-col items-center justify-center overflow-hidden", "before:absolute before:bottom-0 before:left-0 before:right-0", "before:top-0 before:z-[1] before:bg-black/60 before:content-['']", onHome && "rounded-2xl"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative h-full w-full transition-all duration-300 ease-in-out group-hover:scale-105",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "img-prod-exclusive opacity-60",
                            src: backgroundOppo,
                            alt: "Smartphone Oppo com tampa traseira transparente mostrando componentes internos e c\xe2meras em destaque, com inscri\xe7\xe3o Powered by MariSilicon sobre fundo preto."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute z-[1] flex h-full flex-col items-center justify-center py-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex border-mglGray50",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "img-prod-exclusive opacity-60",
                                    width: 190,
                                    height: 45,
                                    src: "/oppo-logo.png",
                                    alt: "none"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "py-6",
                                children: [
                                    !onHome && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-center text-2xl font-bold text-mglGray50",
                                        children: textsLinks.onLp.subtitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "max-w-[280px] text-center text-base text-mglGray50 sm:max-w-full",
                                        children: onHome ? textsLinks.onHome.describe : textsLinks.onLp.describe
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "rounded-full border-0 px-8 py-4 text-2xl shadow-[0_3px_0_0_#0086ff]",
                                texto: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
                                color: "black",
                                title: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
                                borderColor: "white",
                                chipSize: "medium",
                                backgroundColor: "white",
                                link: onHome ? textsLinks.onHome.link : textsLinks.onLp.link,
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        ]
                    })
                ]
            })
        }, "#")
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 2835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsTimeLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5877);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9659);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2153);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6008);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_5___default()().publicRuntimeConfig;
var icons = {
    video: "mdi:video",
    podcast: "mdi:microphone",
    webStories: "mdi:view-carousel"
};
function NewsTimeLine(param) {
    var news = param.news, _image = param.image, image = _image === void 0 ? true : _image, _effectImage = param.effectImage, effectImage = _effectImage === void 0 ? true : _effectImage, _title = param.title, title = _title === void 0 ? true : _title, propsTitle = param.propsTitle, _autor = param.autor, autor = _autor === void 0 ? false : _autor, propsAutor = param.propsAutor, metaInfo = param.metaInfo, propsMetaInfo = param.propsMetaInfo, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _url = param.url, url = _url === void 0 ? null : _url, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag;
    var ref;
    var variants = {
        ItemList: {
            effectImage: {
                true: "[&_.image-container]:hover:scale-105",
                false: ""
            },
            colorInHover: {
                true: "transition-colors duration-300 ease-ease [&_h3]:hover:text-mglBlue400",
                false: ""
            }
        },
        Image: {
            imgRounded: {
                true: "rounded-half border-[3px] border-solid border-mglGray200",
                false: ""
            }
        },
        Title: {
            autorNoMargin: {
                true: "tablet:m-0 mt-0",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsListContainerSpan = currentSpan && currentSpan.startChild({
        op: "newsListContainer"
    });
    var Heading = headingTag;
    url || (url = news.url);
    if (isSubDomain && !url.match(/^https?:/)) {
        url = "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(url);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative mx-0 mb-0 mt-4 hover:cursor-pointer tablet:my-4 [&_a]:text-[inherit]", propsTitle.altColorInHover && !!propsTitle.colorHover && variants.ItemList.colorInHover[(propsTitle.altColorInHover && !!propsTitle.colorHover).toString()], effectImage != undefined && variants.ItemList.effectImage[effectImage.toString()]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    rel: news.id,
                    title: news.titulo,
                    className: "jc",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "box relative flex overflow-hidden rounded-lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image-container relative flex h-full w-full transition-transform duration-300 ease-ease [&>figure]:aspect-video",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: news.imagem.url,
                                        alt: news.titulo,
                                        blurhash: news.imagem.blurhash
                                    })
                                }),
                                autor && propsAutor && propsAutor.image && propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-2 left-2 h-10 w-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                        src: news.colunista.imagem.url,
                                        alt: news.autor,
                                        width: 40,
                                        height: 40
                                    })
                                }),
                                (news.tipo === "video" || news.tipo === "webStories" || news.tipo === "podcast") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-[10px] left-[10px] z-[2] flex h-10 w-10 items-center justify-center rounded-half border-[6px] border-solid border-[#999] bg-[#999] text-[2.5rem]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: icons[news.tipo],
                                        width: "1em",
                                        color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
                                    })
                                })
                            ]
                        }),
                        autor && propsAutor && propsAutor.image && !propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative -bottom-2 mb-4 ml-0 mr-2 mt-0 inline-block h-10 w-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                src: news.colunista.imagem.url,
                                alt: news.autor
                            })
                        }),
                        autor && propsAutor && propsAutor.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mx-0 mb-2 mt-4 inline-block text-xs text-black/40",
                            children: news.autor
                        }),
                        metaInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-[10px] mt-5 flex flex-row text-xs leading-none",
                            children: [
                                propsMetaInfo && propsMetaInfo.age && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex flex-row items-center font-medium text-black/40 [&_svg]:mr-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            icon: "mdi:clock-outline",
                                            width: "12",
                                            height: "12"
                                        }),
                                        news.idade
                                    ]
                                }),
                                propsMetaInfo && propsMetaInfo.age && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-1 my-0 h-auto border-0 border-l-[0.5px] border-solid border-[#999]"
                                }),
                                propsMetaInfo && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-medium uppercase text-black/40",
                                    children: news.categoria
                                })
                            ]
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mt-4 text-lg font-medium text-mglGray900 tablet:mx-0 tablet:mb-0", (propsAutor && !!propsAutor.text || metaInfo && !!propsMetaInfo) && variants.Title.autorNoMargin.true),
                            style: propsTitle.color ? {
                                color: propsTitle.color
                            } : {},
                            children: news.titulo
                        })
                    ]
                })
            }),
            newsListContainerSpan && newsListContainerSpan.finish()
        ]
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 1530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfileLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function ProfileLinks(param) {
    var links = param.links, type = param.type;
    var profileIcons = {
        website: "mdi:earth",
        facebook: "mdi:facebook",
        twitter: "mdi:twitter",
        instagram: "mdi:instagram",
        youtube: "mdi:youtube",
        linkedin: "mdi:linkedin"
    };
    var variants = {
        hasGrayBackground: {
            true: {
                background: "bg-mglGray100 ",
                hover: "group-focus:text-mglGray500 group-hover:text-mglGray500"
            },
            false: {
                background: "bg-mglBlue50 ",
                hover: "group-focus:text-mglBlue200 group-hover:text-mglBlue200"
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex flex-wrap justify-center gap-2",
        children: Object.entries(links).map(function(link) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex h-8 w-8 items-center justify-center rounded-half bg-mglBlue50 transition-colors duration-300 ease-ease [&>a>svg>path]:transition-colors [&>a>svg>path]:duration-300 [&>a>svg>path]:ease-ease focus:[&>a>svg>path]:text-mglGray500 [&>a]:flex", variants.hasGrayBackground[(type !== "autor").toString()].background),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: "_blank",
                    href: link[1],
                    rel: "noreferrer",
                    title: "".concat(link[0].charAt(0).toUpperCase() + link[0].slice(1)),
                    className: "group",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        width: 24,
                        height: 24,
                        color: type === "autor" ? _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglBlue.mglBlue400 */ .Db.mglBlue400 : _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray700 */ .Ce.mglGray700,
                        icon: profileIcons[link[0]],
                        className: variants.hasGrayBackground[(type !== "autor").toString()].hover
                    })
                })
            }, link[0]);
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony exports sponsoredCategoriesUri, getEditorialCategoryWithStringToInternal */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ],
    smartphone: [
        {
            url: "https://www.motorola.com.br/",
            title: "Ir para o site da Motorola!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais",
    "smartphone"
];
var sponsoredCategoriesUri = (/* unused pure expression or super */ null && ([
    "tutoriais",
    "smartphone"
]));
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (singleCategory === "tutoriais") return "tutoriais";
    if (singleCategory === "smartphone") return "smartphone";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro" || singleCategory === "ct-eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ }),

/***/ 9153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CompanyProfile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/assets/svg/ctlogo.svg
var ctlogo = __webpack_require__(3535);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/assets/svg/ct_ofertas_white.svg
var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgCtOfertasWhite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 30,
    viewBox: "0 0 206 30",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M44.927 12.227c-.72 0-1.27.267-1.647.836-.412.569-.584 1.339-.584 2.342 0 2.075.79 3.112 2.403 3.112.48 0 .96-.067 1.407-.2.446-.134.927-.302 1.373-.47v2.444c-.927.401-1.956.602-3.123.602-1.648 0-2.952-.469-3.81-1.406-.892-.936-1.339-2.308-1.339-4.082 0-1.104.206-2.074.653-2.944.446-.837 1.03-1.506 1.853-1.94.79-.47 1.75-.67 2.849-.67 1.2 0 2.333.268 3.397.77l-.926 2.275c-.412-.2-.824-.335-1.236-.469a3.877 3.877 0 00-1.27-.2zM56.768 20.725l-.549-2.007h-3.57l-.549 2.007h-3.26l3.604-10.774h3.981l3.638 10.774h-3.295zm-1.132-4.383l-.48-1.773c-.104-.402-.241-.904-.413-1.506-.171-.636-.274-1.07-.309-1.338-.034.234-.137.669-.274 1.238-.138.568-.412 1.706-.893 3.379h2.369zM71.698 20.725h-3.913l-4.015-7.562h-.07a32.97 32.97 0 01.138 2.71v4.852h-2.643V9.985h3.879l4.015 7.461h.035a42.49 42.49 0 01-.103-2.61V9.985h2.642v10.74h.035zM80.829 20.725l-.55-2.007H76.71l-.549 2.007h-3.26l3.603-10.774h3.981l3.604 10.774h-3.26zm-1.133-4.383l-.48-1.773c-.103-.402-.24-.904-.412-1.506-.172-.636-.275-1.07-.31-1.338-.034.234-.136.669-.274 1.238a76.553 76.553 0 01-.892 3.379h2.368zM85.29 20.725V9.985h2.985v8.398h4.256v2.342h-7.242zM99.122 20.725h-2.986V12.36H93.46V9.986h8.34v2.376h-2.677v8.364zM109.898 20.725h-6.521V9.985h6.521v2.342h-3.569V14h3.295v2.342h-3.295v2.041h3.569v2.342zM116.728 12.227c-.721 0-1.27.267-1.647.836-.412.569-.584 1.339-.584 2.342 0 2.075.79 3.112 2.403 3.112.48 0 .961-.067 1.407-.2.446-.134.927-.302 1.373-.47v2.444c-.927.401-1.957.602-3.124.602-1.647 0-2.951-.469-3.809-1.406-.893-.936-1.339-2.308-1.339-4.082 0-1.104.206-2.074.652-2.944.447-.837 1.03-1.506 1.854-1.94.789-.47 1.75-.67 2.848-.67a7.88 7.88 0 013.398.77l-.926 2.275c-.412-.2-.824-.335-1.236-.469-.343-.133-.789-.2-1.27-.2zM131.28 20.725h-2.986v-4.383h-3.466v4.383h-2.986V9.985h2.986v3.982h3.466V9.985h2.986v10.74zM148.544 15.338c0 1.807-.446 3.18-1.373 4.116-.892.937-2.23 1.405-3.981 1.405-1.716 0-3.054-.468-3.981-1.405s-1.373-2.309-1.373-4.116c0-1.773.446-3.145 1.373-4.082.927-.937 2.231-1.405 3.981-1.405 1.751 0 3.089.468 3.981 1.405.927.904 1.373 2.276 1.373 4.082zm-7.585 0c0 2.075.755 3.112 2.231 3.112.755 0 1.304-.267 1.682-.77.377-.501.549-1.304.549-2.341 0-1.071-.172-1.874-.549-2.376-.378-.502-.927-.77-1.648-.77-1.51 0-2.265 1.037-2.265 3.146zM153.453 20.725h-2.918V9.985h6.521v2.342h-3.569v2.041h3.295v2.342h-3.295v4.015h-.034zM165.363 20.725h-6.521V9.985h6.521v2.342h-3.57V14h3.295v2.342h-3.295v2.041h3.57v2.342zM170.271 16.81v3.915h-2.986V9.985h3.638c2.986 0 4.496 1.07 4.496 3.179 0 1.238-.617 2.208-1.853 2.877l3.192 4.684h-3.364l-2.333-3.914h-.79zm0-2.174h.549c1.03 0 1.545-.435 1.545-1.339 0-.736-.515-1.104-1.545-1.104h-.583v2.443h.034zM182.593 20.725h-2.986V12.36h-2.677V9.986h8.34v2.376h-2.677v8.364zM193.61 20.725l-.549-2.007h-3.57l-.549 2.007h-3.26l3.569-10.774h3.981l3.639 10.774h-3.261zm-1.167-4.417l-.48-1.773a63.717 63.717 0 00-.412-1.505c-.172-.636-.275-1.071-.309-1.339-.035.234-.137.67-.275 1.238a76.696 76.696 0 01-.892 3.38h2.368zM205.244 17.446c0 .67-.172 1.272-.515 1.774s-.858.903-1.51 1.204c-.652.302-1.407.435-2.3.435-.72 0-1.338-.067-1.853-.134-.515-.066-1.03-.267-1.545-.535v-2.576c.584.267 1.167.502 1.785.669a6.355 6.355 0 001.682.234c.446 0 .755-.067.961-.234a.653.653 0 00.309-.569.632.632 0 00-.137-.401 1.044 1.044 0 00-.412-.335c-.172-.1-.687-.335-1.476-.703-.721-.334-1.27-.635-1.613-.936-.343-.302-.618-.636-.79-1.038a3.392 3.392 0 01-.274-1.372c0-1.003.377-1.773 1.098-2.308.755-.57 1.751-.837 3.055-.837 1.132 0 2.299.268 3.501.77l-.927 2.242c-1.03-.469-1.922-.703-2.677-.703-.378 0-.652.067-.858.2-.172.135-.275.302-.275.503 0 .2.103.401.343.568.241.168.824.469 1.819.904.961.401 1.614.87 1.991 1.338.446.536.618 1.138.618 1.84zM15.186 29.984c8.387 0 15.186-6.504 15.186-14.527S23.573.93 15.186.93 0 7.434 0 15.457s6.8 14.527 15.186 14.527z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10.16 22.738c1.428 0 2.585-1.107 2.585-2.473 0-1.365-1.157-2.471-2.585-2.471-1.427 0-2.584 1.106-2.584 2.471 0 1.366 1.157 2.473 2.584 2.473zM20.213 13.12c1.427 0 2.584-1.106 2.584-2.472 0-1.365-1.157-2.472-2.584-2.472s-2.584 1.107-2.584 2.472c0 1.366 1.157 2.472 2.584 2.472zM7.557 8.092c1.095-1.047 2.87-1.047 3.964 0L22.956 19.03a2.6 2.6 0 010 3.792c-1.095 1.047-2.87 1.047-3.964 0L7.557 11.884a2.6 2.6 0 010-3.792z",
    fill: "#0086FF"
  })));
}
/* harmony default export */ var ct_ofertas_white = (SvgCtOfertasWhite);
;// CONCATENATED MODULE: ./src/components/Layout/Footer/index.tsx



function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-[#333333] pt-12 text-mglGray50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-[1200px] px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 gap-8 tablet:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-6 md:items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-56 items-center justify-center gap-2 md:justify-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ctlogo/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ct_ofertas_white, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gap-3md:items-start flex flex-col items-center md:items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mb-2 text-lg font-bold text-white",
                                    children: "Sobre o Canaltech"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/sobre",
                                    title: "Canaltech",
                                    className: "text-sm text-mglGray50 hover:text-white",
                                    children: "Canaltech"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://ofertas.canaltech.com.br/",
                                    title: "Canaltech Ofertas",
                                    className: "text-sm text-mglGray50 hover:text-white",
                                    children: "Canaltech Ofertas"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://ofertas.canaltech.com.br/grupos-de-oferta/",
                                    title: "Grupo de Ofertas",
                                    className: "text-sm text-mglGray50 hover:text-white",
                                    children: "Grupo de Ofertas"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://canaltech.com.br/privacidade/",
                                    title: "Politica de Privacidade",
                                    className: "text-sm text-mglGray50 hover:text-white",
                                    children: "Pol\xedtica de Privacidade"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-3 md:items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mb-2 text-lg font-bold",
                                    children: "Nossas Redes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://instagram.com/canaltech",
                                            title: "Instagram Oficial do Canaltech",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: " text-white hover:opacity-80",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: " h-6 w-6 fill-current text-white",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://facebook.com/canaltech",
                                            target: "_blank",
                                            title: "Facebook Oficial do Canaltech",
                                            rel: "noopener noreferrer",
                                            className: " text-white hover:opacity-80",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: " h-6 w-6 fill-current text-white",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://twitter.com/canaltech",
                                            target: "_blank",
                                            title: "X/Twitter Oficial do Canaltech",
                                            rel: "noopener noreferrer",
                                            className: " text-white hover:opacity-80",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: " h-6 w-6 fill-current text-white",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://linkedin.com/company/canaltech-brasil",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: " text-white hover:opacity-80",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "h-6 w-6 fill-current",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 border-t border-mglGray700 bg-mglGray900 p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center text-xs text-mglGray400",
                    children: "Unilogic Media Group Ltda com CNPJ 09.081.439/0001-60, na Rua Maria Prestes Maia, 300, Vila Guilherme, S\xe3o Paulo, Estado de S\xe3o Paulo"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/Layout/Accordion/index.tsx
var Accordion = __webpack_require__(4934);
// EXTERNAL MODULE: ./src/components/Layout/Title/index.tsx
var Title = __webpack_require__(9879);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Profile/ProfileHeader/ProfileLinks/index.tsx
var ProfileLinks = __webpack_require__(1530);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
// EXTERNAL MODULE: ./src/components/Layout/Container/index.tsx
var Container = __webpack_require__(1080);
// EXTERNAL MODULE: ./src/components/Home/FeaturedLastNews/index.tsx + 6 modules
var FeaturedLastNews = __webpack_require__(2826);
// EXTERNAL MODULE: ./src/components/Layout/FeaturedProductExclusive/index.tsx
var FeaturedProductExclusive = __webpack_require__(8157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Internals/CompanyHero/index.tsx








var DEFAULT_FALLBACK_PARAGRAPHS = [
    "Esta empresa desenvolve produtos e servi\xe7os que impactam o dia a dia de milh\xf5es de pessoas ao redor do mundo.",
    "A inova\xe7\xe3o constante e o foco na experi\xeancia do usu\xe1rio fazem parte do DNA da companhia.", 
];
function CompanyHero(param) {
    var content = param.content, companyName = param.companyName, companySlug = param.companySlug, scrollMarginTop = param.scrollMarginTop, _sectionId = param.sectionId, sectionId = _sectionId === void 0 ? companySlug : _sectionId, _backgroundImageUrl = param.backgroundImageUrl, backgroundImageUrl = _backgroundImageUrl === void 0 ? "https://t.ctcdn.com.br/WevcqeQI5YN4s6lIbCRafr8WOjE=/i1068817.jpeg" : _backgroundImageUrl, ctaHref = param.ctaHref, _ctaLabel = param.ctaLabel, ctaLabel = _ctaLabel === void 0 ? "Saiba mais" : _ctaLabel, _fallbackParagraphs = param.fallbackParagraphs, fallbackParagraphs = _fallbackParagraphs === void 0 ? DEFAULT_FALLBACK_PARAGRAPHS : _fallbackParagraphs, heading = param.heading;
    var normalizedHeading = heading || "Sobre a ".concat(companyName);
    var heroCtaHref = ctaHref || "/empresa/".concat(companySlug, "/produtos/");
    var paragraphs = (0,react.useMemo)(function() {
        if (!content) {
            return fallbackParagraphs.map(function(paragraph, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base leading-relaxed text-mglGray900/80",
                    children: paragraph
                }, "fallback-".concat(index));
            });
        }
        if (typeof content === "string") {
            return content.split("\n").map(function(item) {
                return item.trim();
            }).filter(Boolean).slice(0, 2).map(function(paragraph, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base leading-relaxed text-mglGray900/80",
                    children: paragraph
                }, "string-content-".concat(index));
            });
        }
        var normalizedParagraphs = content.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.tipo) !== "html";
        }).slice(0, 2);
        if (normalizedParagraphs.length === 0) {
            return fallbackParagraphs.map(function(paragraph, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base leading-relaxed text-mglGray900/80",
                    children: paragraph
                }, "fallback-".concat(index));
            });
        }
        return normalizedParagraphs.map(function(item, index) {
            return /*#__PURE__*/ (0,react.createElement)(ContentComposer/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: "content-".concat(item.tipo, "-").concat(index),
                className: (0,className/* default */.Z)("text-base leading-relaxed text-mglGray900/80", item.className)
            }));
        });
    }, [
        content,
        fallbackParagraphs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: sectionId,
        "aria-labelledby": "".concat(sectionId, "-title"),
        className: "relative isolate w-full overflow-hidden",
        style: {
            scrollMarginTop: scrollMarginTop
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-white bg-cover bg-left bg-no-repeat desktop:bg-[size:120%]",
                style: {
                    backgroundImage: "url('".concat(backgroundImageUrl, "')")
                },
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-gradient-to-r from-white via-white/20 to-transparent",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                isOnHeader: true,
                backgroundColor: "transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative z-10 flex min-h-[650px] w-full flex-col justify-center gap-6 px-6 py-10 text-mglGray900 phone:px-8 tablet:max-w-[540px] tablet:px-12 desktop:max-w-[620px] desktop:px-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            id: "".concat(sectionId, "-title"),
                            className: "text-3xl font-bold leading-tight text-mglGray900 tablet:text-4xl",
                            children: normalizedHeading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-4 font-thin",
                            children: paragraphs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: heroCtaHref,
                            className: "flex items-center justify-center self-start rounded-full border border-b-2 bg-mglBlue400 px-16 py-4 text-white shadow-[0_4px_0_0_#ffffff] transition-colors duration-200 hover:bg-mglBlue300 phone:justify-center",
                            children: ctaLabel
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
;// CONCATENATED MODULE: ./src/components/Layout/PageSummaryNavigation/index.tsx





var DEFAULT_FALLBACK_MARGIN = 140;
function PageSummaryNavigation(param) {
    var anchors = param.anchors, _summaryStickyTop = param.summaryStickyTop, summaryStickyTop = _summaryStickyTop === void 0 ? 0 : _summaryStickyTop, _fallbackScrollMargin = param.fallbackScrollMargin, fallbackScrollMargin = _fallbackScrollMargin === void 0 ? DEFAULT_FALLBACK_MARGIN : _fallbackScrollMargin, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, onSectionsMarginChange = param.onSectionsMarginChange, onActiveAnchorChange = param.onActiveAnchorChange;
    var ref;
    var validAnchors = (0,react.useMemo)(function() {
        return anchors.filter(function(anchor) {
            return Boolean((anchor === null || anchor === void 0 ? void 0 : anchor.href) && (anchor === null || anchor === void 0 ? void 0 : anchor.label));
        });
    }, [
        anchors
    ]);
    var ref1 = (0,react.useState)(((ref = validAnchors[0]) === null || ref === void 0 ? void 0 : ref.href) || ""), activeAnchor = ref1[0], setActiveAnchor = ref1[1];
    var activeAnchorRef = (0,react.useRef)(activeAnchor);
    var summaryBlockRef = (0,react.useRef)(null);
    var summaryNavRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), summaryHeight = ref2[0], setSummaryHeight = ref2[1];
    var ref3 = (0,react.useState)(false), isSummaryPinned = ref3[0], setIsSummaryPinned = ref3[1];
    var anchorScrollOffset = summaryHeight ? summaryStickyTop + summaryHeight : fallbackScrollMargin;
    (0,react.useEffect)(function() {
        if (!validAnchors.length) return;
        if (!validAnchors.some(function(anchor) {
            return anchor.href === activeAnchorRef.current;
        })) {
            var fallbackAnchor = validAnchors[0].href;
            activeAnchorRef.current = fallbackAnchor;
            setActiveAnchor(fallbackAnchor);
            onActiveAnchorChange === null || onActiveAnchorChange === void 0 ? void 0 : onActiveAnchorChange(fallbackAnchor);
        }
    }, [
        validAnchors,
        onActiveAnchorChange
    ]);
    (0,react.useEffect)(function() {
        activeAnchorRef.current = activeAnchor;
        if (activeAnchor) onActiveAnchorChange === null || onActiveAnchorChange === void 0 ? void 0 : onActiveAnchorChange(activeAnchor);
    }, [
        activeAnchor,
        onActiveAnchorChange
    ]);
    (0,react.useEffect)(function() {
        onSectionsMarginChange === null || onSectionsMarginChange === void 0 ? void 0 : onSectionsMarginChange(anchorScrollOffset || fallbackScrollMargin);
    }, [
        anchorScrollOffset,
        fallbackScrollMargin,
        onSectionsMarginChange
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var updateSummaryHeight = function() {
            if (!summaryNavRef.current) return;
            setSummaryHeight(summaryNavRef.current.getBoundingClientRect().height);
        };
        updateSummaryHeight();
        window.addEventListener("resize", updateSummaryHeight);
        var resizeObserver = null;
        if (summaryNavRef.current && "ResizeObserver" in window) {
            resizeObserver = new ResizeObserver(updateSummaryHeight);
            resizeObserver.observe(summaryNavRef.current);
        }
        return function() {
            window.removeEventListener("resize", updateSummaryHeight);
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        };
    }, [
        validAnchors.length
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var updatePinnedState = function() {
            if (!summaryBlockRef.current) return;
            var blockTop = summaryBlockRef.current.getBoundingClientRect().top + window.scrollY;
            setIsSummaryPinned(window.scrollY + summaryStickyTop >= blockTop);
        };
        updatePinnedState();
        window.addEventListener("scroll", updatePinnedState, {
            passive: true
        });
        window.addEventListener("resize", updatePinnedState);
        return function() {
            window.removeEventListener("scroll", updatePinnedState);
            window.removeEventListener("resize", updatePinnedState);
        };
    }, [
        summaryStickyTop
    ]);
    (0,react.useEffect)(function() {
        if ( false || !validAnchors.length) return;
        var availableAnchors = new Set(validAnchors.map(function(anchor) {
            return anchor.href;
        }));
        var updateActiveAnchorFromHash = function() {
            var hash = window.location.hash;
            if (!hash || !availableAnchors.has(hash)) return;
            activeAnchorRef.current = hash;
            setActiveAnchor(hash);
        };
        updateActiveAnchorFromHash();
        window.addEventListener("hashchange", updateActiveAnchorFromHash);
        return function() {
            return window.removeEventListener("hashchange", updateActiveAnchorFromHash);
        };
    }, [
        validAnchors
    ]);
    (0,react.useEffect)(function() {
        if ( false || !validAnchors.length) return;
        var ticking = false;
        var sections = validAnchors.map(function(anchor) {
            return document.querySelector(anchor.href);
        }).filter(function(section) {
            return Boolean(section);
        });
        if (!sections.length) return;
        var getActiveFromScroll = function() {
            var scrollPosition = window.scrollY + anchorScrollOffset + 1;
            var currentSectionId = sections[0].id;
            for(var index = 0; index < sections.length; index += 1){
                var section = sections[index];
                var nextSection = sections[index + 1];
                var sectionTop = section.offsetTop;
                var ref;
                var nextSectionTop = (ref = nextSection === null || nextSection === void 0 ? void 0 : nextSection.offsetTop) !== null && ref !== void 0 ? ref : Number.POSITIVE_INFINITY;
                if (scrollPosition >= sectionTop && scrollPosition < nextSectionTop) {
                    currentSectionId = section.id;
                    break;
                }
            }
            var nextActive = "#".concat(currentSectionId);
            if (activeAnchorRef.current !== nextActive) {
                activeAnchorRef.current = nextActive;
                setActiveAnchor(nextActive);
                if (true) {
                    window.history.replaceState(null, "", nextActive);
                }
            }
        };
        var onScrollOrResize = function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    getActiveFromScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };
        getActiveFromScroll();
        window.addEventListener("scroll", onScrollOrResize, {
            passive: true
        });
        window.addEventListener("resize", onScrollOrResize);
        return function() {
            window.removeEventListener("scroll", onScrollOrResize);
            window.removeEventListener("resize", onScrollOrResize);
        };
    }, [
        anchorScrollOffset,
        validAnchors
    ]);
    var handleAnchorClick = (0,react.useCallback)(function(event, href) {
        event.preventDefault();
        if (false) {}
        var target = document.querySelector(href);
        if (!target) return;
        var prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        target.scrollIntoView({
            behavior: prefersReducedMotion ? "auto" : "smooth",
            block: "start"
        });
        activeAnchorRef.current = href;
        setActiveAnchor(href);
        window.history.replaceState(null, "", href);
    }, []);
    if (!validAnchors.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: summaryBlockRef,
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": true,
                    style: {
                        height: isSummaryPinned ? summaryHeight : 0
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: summaryNavRef,
                    className: (0,className/* default */.Z)("z-30 flex items-center justify-center bg-white/90 backdrop-blur-sm transition-shadow duration-150 ease-ease", isSummaryPinned ? "fixed left-0 right-0 border-b border-mglGray900/10 shadow-[0_12px_34px_rgba(23,23,23,0.08)]" : "relative border-y border-mglGray900/10"),
                    style: isSummaryPinned ? {
                        top: summaryStickyTop
                    } : undefined,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full justify-center px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            "aria-label": "Page summary",
                            className: (0,className/* default */.Z)("flex w-full flex-wrap items-center justify-center gap-2 px-4 py-4 transition-all duration-300 phone:gap-3 tablet:grid tablet:grid-flow-row tablet:grid-cols-6 tablet:gap-4 tablet:px-0", isSummaryPinned && "tablet:mx-4"),
                            children: validAnchors.map(function(anchor) {
                                var isActive = activeAnchor === anchor.href;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    link: anchor.href,
                                    texto: anchor.label,
                                    title: anchor.label,
                                    chipSize: "large",
                                    className: (0,className/* default */.Z)("chip-anchor px-4 transition-[transform,box-shadow] duration-300 ease-ease hover:translate-y-[-1px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 phone:px-6 tablet:px-9", "[&_span]:text-xs [&_span]:font-semibold phone:[&_span]:text-sm", isActive ? "border-0 bg-gradient-to-r from-[#2ba5ff] to-[#60d6ff] text-white shadow-[0_16px_34px_rgba(43,165,255,0.35)] hover:shadow-[0_20px_42px_rgba(43,165,255,0.45)] focus-visible:outline-[#2ba5ff] [&_span]:text-white" : "border border-mglGray900/15 bg-white text-mglGray900 shadow-[0_12px_26px_rgba(23,23,23,0.04)] hover:border-transparent hover:shadow-[0_16px_34px_rgba(23,23,23,0.08)] focus-visible:outline-mglGray200 [&_span]:text-mglGray900"),
                                    onClick: function(event) {
                                        return handleAnchorClick(event, anchor.href);
                                    },
                                    onFocus: function() {
                                        activeAnchorRef.current = anchor.href;
                                        setActiveAnchor(anchor.href);
                                    }
                                }, anchor.href);
                            })
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/oppo/index.tsx

















var FeaturedProducts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3213), __webpack_require__.e(7637), __webpack_require__.e(1812)]).then(__webpack_require__.bind(__webpack_require__, 2909));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2909)
            ];
        }
    },
    ssr: false
});
var VideoSlidersYoutube = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3213), __webpack_require__.e(7637), __webpack_require__.e(5344)]).then(__webpack_require__.bind(__webpack_require__, 5344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5344)
            ];
        }
    },
    ssr: false
});
var SUMMARY_ANCHORS = [
    {
        key: "oppo",
        label: "OPPO",
        href: "#oppo"
    },
    {
        key: "analise",
        label: "Not\xedcias",
        href: "#noticias"
    },
    {
        key: "produtos",
        label: "Produtos",
        href: "#produtos"
    },
    {
        key: "ofertas-oppo",
        label: "Ofertas OPPO",
        href: "#ofertas-oppo"
    },
    {
        key: "videos",
        label: "V\xeddeos",
        href: "#videos"
    },
    {
        key: "faq",
        label: "FAQ",
        href: "#perguntas-frequentes"
    }, 
];
var FALLBACK_SCROLL_MARGIN = 140;
var HEADER_HEIGHT = 0;
var SUMMARY_TOP_GAP = 0;
var __N_SSP = true;
function CompanyProfile(param) {
    var responseData = param.responseData, navBarData = param.navBarData, _timelineData = param.timelineData, timelineData = _timelineData === void 0 ? null : _timelineData;
    var ref;
    var router = (0,next_router.useRouter)();
    var _query = router.query, _empresa = _query.empresa, empresa = _empresa === void 0 ? "oppo" : _empresa;
    var empresaSlug = typeof empresa === "string" ? empresa : Array.isArray(empresa) ? empresa[0] : "oppo";
    var data = responseData.data, segmentacoes = responseData.segmentacoes, schema = responseData.schema, ssr = responseData.ssr;
    var nome = data.nome, imagem = data.imagem, links = data.links, texto = data.texto, produtosEmpresa = data.produtosEmpresa;
    var confirmedProducts = (0,react.useMemo)(function() {
        if (!produtosEmpresa) return [];
        return produtosEmpresa.filter(function(product) {
            return !product.rumor;
        });
    }, [
        produtosEmpresa
    ]);
    var hasProducts = Boolean(confirmedProducts && confirmedProducts.length > 0);
    var anchorItems = (0,react.useMemo)(function() {
        return SUMMARY_ANCHORS.filter(function(item) {
            if (item.key === "produtos") return hasProducts;
            return true;
        });
    }, [
        hasProducts
    ]);
    var heroFallbackParagraphs = (0,react.useMemo)(function() {
        return [
            "".concat(nome, " \xe9 uma marca global que desenvolve produtos e servi\xe7os de tecnologia inteligente voltados para o dia a dia, combinando design minimalista com experi\xeancias sofisticadas."),
            '"Benfen" \xe9 um valor essencial e cren\xe7a inabal\xe1vel para a empresa: manter o usu\xe1rio no centro e usar a paix\xe3o pela inova\xe7\xe3o para criar solu\xe7\xf5es que transformem o cotidiano.', 
        ];
    }, [
        nome
    ]);
    var heroOppoBackgroundUrl = "https://t.ctcdn.com.br/Y0EDOZCj5eo_j3Z-9LAEug9igwk=/i1070389.webp";
    var summaryStickyTop = HEADER_HEIGHT + SUMMARY_TOP_GAP;
    var ref1 = (0,react.useState)(FALLBACK_SCROLL_MARGIN), sectionsScrollMargin = ref1[0], setSectionsScrollMargin = ref1[1];
    var FAQItems = [
        {
            title: "O que \xe9 a OPPO e qual seu prop\xf3sito como marca?",
            content: "A OPPO \xe9 uma empresa global de tecnologia que desenvolve produtos e servi\xe7os inteligentes voltados para o uso cotidiano. Seus dispositivos combinam design minimalista, desempenho avan\xe7ado e uma experi\xeancia intuitiva, com o objetivo de tornar a tecnologia mais humana e acess\xedvel. O prop\xf3sito da marca \xe9 inspirar as pessoas a explorarem sua criatividade de forma simples e significativa, ajudando-as a viver e expressar a beleza da vida em cada momento."
        },
        {
            title: "Quais s\xe3o os valores centrais da OPPO?",
            content: "A OPPO se baseia em princ\xedpios s\xf3lidos que norteiam sua atua\xe7\xe3o global. O principal deles \xe9 o conceito chin\xeas de “Benfen”, que significa fazer o que \xe9 certo, da maneira certa, mantendo sempre uma mente aberta na busca pela verdade. Al\xe9m disso, a empresa coloca o usu\xe1rio no centro de todas as decis\xf5es, valorizando a inova\xe7\xe3o tecnol\xf3gica, o design com prop\xf3sito e o compromisso com a qualidade. H\xe1 tamb\xe9m uma forte paix\xe3o pela cria\xe7\xe3o e pela melhoria constante da experi\xeancia do consumidor, sempre com foco em impacto positivo e duradouro."
        },
        {
            title: "A OPPO oferece assist\xeancia t\xe9cnica no Brasil? Como funciona o suporte ao cliente?",
            content: "Sim, a OPPO oferece assist\xeancia t\xe9cnica autorizada no Brasil, com centros de servi\xe7o em diversas regi\xf5es e suporte digital acess\xedvel. A empresa entende que um bom atendimento p\xf3s-venda \xe9 essencial para a confian\xe7a do consumidor, por isso investe em canais de atendimento humanizados e eficientes. \xc9 poss\xedvel tirar d\xfavidas, solicitar reparos e acompanhar o status do servi\xe7o por meio do site oficial ou atendimento via WhatsApp. A garantia dos produtos segue as regras do C\xf3digo de Defesa do Consumidor brasileiro, e a OPPO est\xe1 comprometida em oferecer suporte r\xe1pido e transparente para garantir tranquilidade a quem escolhe a marca."
        },
        {
            title: "Em quantos pa\xedses a OPPO opera e qual \xe9 sua presen\xe7a global?",
            content: "Fundada em 2004, a OPPO expandiu-se rapidamente e hoje est\xe1 presente em mais de 70 pa\xedses e regi\xf5es. Conta com uma equipe global de mais de 40 mil funcion\xe1rios, o que reflete o alcance e a diversidade cultural de suas opera\xe7\xf5es. Essa presen\xe7a internacional permite que a marca adapte seus produtos \xe0s necessidades de diferentes p\xfablicos, mantendo a mesma qualidade e filosofia em todos os mercados."
        },
        {
            title: "Como \xe9 a qualidade de fabrica\xe7\xe3o dos produtos OPPO?",
            content: "A OPPO investe pesadamente em qualidade e controle de produ\xe7\xe3o. Seus dispositivos s\xe3o fabricados de acordo com os padr\xf5es mais rigorosos da ind\xfastria e passam por processos de teste minuciosos em cada etapa. A empresa possui nove centros de produ\xe7\xe3o espalhados pelo mundo, todos equipados com tecnologia de ponta. Al\xe9m disso, seus produtos cumprem as exig\xeancias das principais operadoras de telefonia globais, o que assegura compatibilidade e desempenho confi\xe1vel em qualquer mercado."
        },
        {
            title: "Qual \xe9 o slogan da OPPO e o que ele significa?",
            content: "O slogan da OPPO \xe9 “Make Your Moment”, uma express\xe3o que reflete a filosofia central da marca: transformar momentos comuns em experi\xeancias extraordin\xe1rias. A ideia \xe9 que cada pessoa possa aproveitar o presente, criar algo novo e se expressar plenamente, usando a tecnologia como uma ferramenta para ampliar a pr\xf3pria criatividade e autenticidade."
        },
        {
            title: "Quantos usu\xe1rios usam o sistema operacional da OPPO (ColorOS)?",
            content: "O sistema operacional da OPPO, chamado ColorOS, \xe9 utilizado por mais de 700 milh\xf5es de pessoas em todo o mundo. Essa base de usu\xe1rios demonstra a robustez, a estabilidade e a aceita\xe7\xe3o global do ecossistema da marca, que combina desempenho com uma interface amig\xe1vel e altamente personaliz\xe1vel."
        },
        {
            title: "Com quais marcas ou organiza\xe7\xf5es a OPPO colabora?",
            content: "A OPPO mant\xe9m parcerias estrat\xe9gicas com grandes nomes globais tanto no campo tecnol\xf3gico como esportivo e de m\xeddia. A marca estabeleceu colabora\xe7\xe3o com a UEFA Champions League e trabalha com a Hasselblad em sistemas de fotografia m\xf3vel de alta performance. Em outubro de 2025, firmou tamb\xe9m uma parceria com o Canaltech, integrando conte\xfados, promo\xe7\xf5es ou iniciativas conjuntas que buscam aproximar o p\xfablico consumidor brasileiro \xe0 inova\xe7\xe3o da OPPO atrav\xe9s da cobertura especializada do Canaltech."
        },
        {
            title: "Por que confiar em uma marca como a OPPO?",
            content: "A China \xe9 hoje um dos maiores polos de inova\xe7\xe3o tecnol\xf3gica do mundo, e a OPPO est\xe1 entre as marcas l\xedderes dessa transforma\xe7\xe3o. Com mais de 20 anos de experi\xeancia, a empresa investe pesado em pesquisa e desenvolvimento, possui centros pr\xf3prios de inova\xe7\xe3o e j\xe1 foi pioneira em diversas tecnologias m\xf3veis. Sua presen\xe7a em mais de 70 pa\xedses e parcerias com empresas reconhecidas mundialmente demonstram a solidez da marca. No Brasil, a OPPO respeita normas locais, oferece suporte ao consumidor e tem como compromisso oferecer produtos confi\xe1veis e dur\xe1veis, valorizando a experi\xeancia do usu\xe1rio brasileiro com a mesma seriedade com que atua em mercados como Europa e \xc1sia."
        },
        {
            title: "H\xe1 quanto tempo a OPPO atua no Brasil?",
            content: "A OPPO iniciou oficialmente sua atua\xe7\xe3o no Brasil em 2022, trazendo para o pa\xeds seus smartphones e tecnologias que j\xe1 conquistaram usu\xe1rios em diversos mercados. Desde ent\xe3o, tem expandido sua presen\xe7a com parceiros locais, canais de venda confi\xe1veis, suporte t\xe9cnico autorizado e uma comunica\xe7\xe3o mais pr\xf3xima do consumidor brasileiro. Apesar de ser relativamente recente no Brasil, a OPPO j\xe1 demonstrou seu compromisso com o mercado nacional ao investir em estrutura, atendimento e conte\xfado local, buscando construir uma rela\xe7\xe3o de longo prazo com os brasileiros."
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                layoutData: {
                    navBarData: navBarData,
                    segmentacoes: segmentacoes,
                    tagsData: ssr,
                    schema: schema
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col items-center bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            className: "flex flex-col items-center justify-center pb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: imagem.url,
                                    width: 120,
                                    height: 120,
                                    alt: nome
                                }),
                                links && Object.values(links).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLinks/* default */.Z, {
                                    links: links,
                                    type: "empresa"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyHero, {
                            content: texto,
                            companyName: nome,
                            companySlug: empresaSlug,
                            scrollMarginTop: sectionsScrollMargin,
                            sectionId: "oppo",
                            backgroundImageUrl: heroOppoBackgroundUrl,
                            heading: "Sobre a ".concat(nome),
                            fallbackParagraphs: heroFallbackParagraphs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSummaryNavigation, {
                            anchors: anchorItems.map(function(param) {
                                var href = param.href, label = param.label;
                                return {
                                    href: href,
                                    label: label
                                };
                            }),
                            summaryStickyTop: summaryStickyTop,
                            fallbackScrollMargin: FALLBACK_SCROLL_MARGIN,
                            backgroundColor: "white",
                            onSectionsMarginChange: setSectionsScrollMargin
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "noticias",
                            className: "w-full",
                            style: {
                                scrollMarginTop: sectionsScrollMargin
                            },
                            children: (timelineData === null || timelineData === void 0 ? void 0 : (ref = timelineData.data) === null || ref === void 0 ? void 0 : ref.timeline) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedLastNews["default"], {
                                featuredLastNewsData: timelineData.data.timeline,
                                rootPage: "oppo",
                                textTitle: "\xdaltimas sobre ".concat(nome),
                                route: empresaSlug,
                                routeType: "empresa",
                                useLoadMoreButton: true,
                                backgroundColor: "bg-white",
                                hideAds: true
                            })
                        }),
                        hasProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "produtos",
                            className: "w-full",
                            style: {
                                scrollMarginTop: sectionsScrollMargin
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts, {
                                featuredProductsData: confirmedProducts,
                                title: "Produtos ".concat(nome),
                                shouldShowChip: true,
                                url: "/empresa/".concat(empresaSlug, "/produtos/")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "ofertas-oppo",
                            className: "w-full",
                            style: {
                                scrollMarginTop: sectionsScrollMargin
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProductExclusive/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "videos",
                            className: "w-full",
                            style: {
                                scrollMarginTop: sectionsScrollMargin
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                                backgroundColor: designSystemColors/* mglGray.mglGray100 */.Ce.mglGray100,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSlidersYoutube, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "perguntas-frequentes",
                            className: "w-full",
                            style: {
                                scrollMarginTop: sectionsScrollMargin
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                                backgroundColor: designSystemColors/* mglGray.mglGray100 */.Ce.mglGray100,
                                paddingOnBottom: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "m-4 md:mx-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                            texto: "Perguntas frequentes",
                                            color: "black"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                        items: FAQItems,
                                        blueTheme: true
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,4538,8802,7590,944,2826,9774,2888,179], function() { return __webpack_exec__(6538); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);